export enum CameraMode {
    Rotating = 0,
    Random = 1,
    Orbiting = 2,
    FPS = 3,
    FrontEnd = 4
};
